import DOMPurify from "dompurify";

/**
 * Sanitizes HTML content to prevent XSS attacks.
 * Use this instead of raw dangerouslySetInnerHTML.
 */
export const sanitizeHtml = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html);
};

/**
 * Returns a sanitized object for dangerouslySetInnerHTML.
 * Usage: <div {...safeHtml(content)} />
 */
export const safeHtml = (html) => ({
  dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
});

// Nur diese Hosts dürfen in einem <iframe> eingebettet werden (Video-Embeds).
const ALLOWED_IFRAME_HOSTS = [
  "www.youtube.com",
  "youtube.com",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "player.vimeo.com",
];

/**
 * Sanitizes embed HTML that may contain an <iframe> (z.B. YouTube/Vimeo).
 * Anders als sanitizeHtml() wird <iframe> erlaubt – aber nur mit src aus einer
 * Host-Allowlist. Alles andere (Scripts, fremde iframes) wird entfernt.
 * Usage: <div {...safeEmbed(content)} />
 */
export const safeEmbed = (html) => {
  if (!html) return { dangerouslySetInnerHTML: { __html: "" } };

  DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    if (data.tagName !== "iframe") return;
    let host = "";
    try {
      host = new URL(node.getAttribute("src") || "").host;
    } catch (e) {
      host = "";
    }
    if (!ALLOWED_IFRAME_HOSTS.includes(host)) {
      node.parentNode?.removeChild(node);
    }
  });

  let clean = "";
  try {
    clean = DOMPurify.sanitize(html, {
      ADD_TAGS: ["iframe"],
      ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "src", "title"],
    });
  } finally {
    DOMPurify.removeHook("uponSanitizeElement");
  }

  return { dangerouslySetInnerHTML: { __html: clean } };
};
